export const TRANSLATIONS_EN = {
  approveAdmin:
    'Please click on the approve/decline button to approve or decline the admin',
  pendingAdminApprovals: 'Pending Admin Approvals',
  ApprovedAdmins: 'Approved Admins',
  Listofapprovedadmins:
    'The list below mentions the list of approved admins in the system. Please click remove to strip them of admin status.',
  Coursesthatrequireyourapproval: 'Courses that require your approval',
  approveordeclinethecourse:
    'Please click on the approve/decline button to approve or decline the course.',
  AllCourses: 'All Courses',
  listofallthecurrentcourses:
    'The list below shows a list of all the current courses.',
  NoPendingcourseapprovalrequests: 'No Pending course approval requests.',
  NoPendingAdmins: 'No Pending Admins.',
  NoApprovedAdmins: 'No Approved Admins',
  Nocourses: 'No courses',
  PENDINGADMINS: 'PENDING ADMINS',
  APPROVEDADMINS: 'APPROVED ADMINS',
  PENDINGCOURSES: 'PENDING COURSES',
  APPROVEDCOURSES: 'APPROVED COURSES',
  SUGGESTADMIN: 'SUGGEST ADMIN',
  Name: 'Name',
  Email: 'Email',
  Nameofrequester: 'Name of requester',
  Reasonforrequest: 'Reason for request',
  Actions: 'Actions',
  Username: 'Username',
  Approve: 'Approve',
  Decline: 'Decline',
  Remove: 'Remove',
  CourseName: 'Course Name',
  CourseDescription: 'Course Description',
  Description: 'Description',
  Logout: 'Logout',
  AdminName: 'Admin Name',
  Statusofrequest: 'Status of request',
  SuggestedAdminStatus: 'Suggested Admin Status',
  specifyreasonadminsuggestion: 'Specify a reason for the admin suggestion:',
  EnterReason: 'Enter Reason',
  Thiscategoryhasnocourses: 'This category has no courses',
  AddNewCourse: 'Add New Course',
  Thiscoursehasnosections: 'This course has no sections',
  Thissectionhasnolectures: 'This section has no lectures',
  AddNewLecture: 'Add New Lecture',
  HOME: 'HOME',
  MYCOURSES: 'MY COURSES',
  STATISTICS: 'STATISTICS',
  Pleasechooseacategorytoaddacourse:
    'Please choose a category to add a course.',
  Pleasechooseasectiontoaddalecture:
    'Please choose a section to add a lecture.',
  AddSection: 'Add Section',
  ADD: 'ADD',
  Checkthestatusofyourcourses: 'Check the status of your courses',
  AdminComment: 'Admin Comment',
  Status: 'Status',
  CourseType: 'Course Type',
  TotalLectures: 'Total Lectures',
  TotalCourses: 'Total Courses',
  TotalSections: 'Total Sections',
  TotalCategories: 'Total Categories',
  EnrolledCourses: 'Enrolled Courses',
  ENROLLEDCOURSES: 'ENROLLED COURSES',
  ALLCOURSES: 'ALL COURSES',
  CONTACTSUPPORT: 'CONTACT SUPPORT',
  FreeCourse: 'Free Course',
  PaidCourse: 'Paid Course',
  ENROLL: 'ENROLL',
  Clicktoviewlectures: 'Click to view lectures',
  WatchLecture: 'Watch Lecture',
  Youarecurrentlynotenrolledinanycourse:
    'You are currently not enrolled in any course',
  GoBack: 'Go Back',
  GoBacktoLectureList: 'Go Back to Lecture List',
  EnterSupportMessage: 'Enter Support Message',
  SEND: 'SEND',
  Thisisafreecourse: 'This is a free course',
  Thisisapaidcourse: 'This is a paid course',
  ThiscoursehasnocontentPleasecheckbacklater:
    'This course has no content. Please check back later',
  AddNote: 'Add Note',
  LectureNotes: 'Lecture Notes',
  NoteDescription: 'Note Description',
  ALLUSERS: 'ALL USERS',
  SUGGESTCATEGORY: 'SUGGEST CATEGORY',
  CategoryName: 'Category Name',
  CategoryDescription: 'Category Description',
  EnterCategoryDescription: 'Enter Category Description'
};
